/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Add null check for sidebar elements
document.addEventListener('DOMContentLoaded', function () {
  // Check if sidebar.js is loaded and handle potential errors
  if (typeof sidebar !== 'undefined' && sidebar) {
    try {
      // Only call methods if the object exists and has the method
      if (sidebar && typeof sidebar.hide === 'function') {
        // Your sidebar code here
      }
    } catch (error) {
      console.warn('Error with sidebar functionality:', error);
    }
  }
});

//B2B Mini Cart Logic// Start
(function () {
  window.B2BPricingMiniCart = window.B2BPricingMiniCart || {};
  const api = window.B2BPricingMiniCart;

  if (api.initialized) return;

  // Guards / scheduling
  api._isApplying = false;
  api._scheduled = false;
  api._scheduleTimer = null;
  api._retryTimer = null;

  api.parseNumber = function (value) {
    if (value === null || value === undefined || value === '') return null;
    const parsed = parseFloat(String(value).replace(',', '.').trim());
    return Number.isNaN(parsed) ? null : parsed;
  };

  api.findMatchingRule = function (rules, productCost) {
    if (!Array.isArray(rules)) return null;

    for (let i = 0; i < rules.length; i += 1) {
      const rule = rules[i];
      if (!rule) continue;

      const min = api.parseNumber(rule.min);
      const max = rule.max === null ? null : api.parseNumber(rule.max);

      const minOk = min === null ? true : productCost >= min;
      const maxOk = max === null ? true : productCost < max;

      if (minOk && maxOk) return rule;
    }

    return null;
  };

  api.formatMoney = function (cents, container) {
    const useCurrencyCode = container.getAttribute('data-b2b-currency-enabled') === 'true';
    const moneyFormat = useCurrencyCode
      ? container.getAttribute('data-b2b-money-format-with-currency')
      : container.getAttribute('data-b2b-money-format');

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const currencyCode = container.getAttribute('data-b2b-currency-code') || 'EUR';
    const locale = document.documentElement.lang || navigator.language || 'en';
    const amount = cents / 100;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: useCurrencyCode ? 'code' : 'symbol',
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + (useCurrencyCode ? ' ' + currencyCode : '');
    }
  };

  api.showFallback = function (container) {
    const fallbackEl = container.querySelector('[data-b2b-price-role="fallback"]');
    const saleEl = container.querySelector('[data-b2b-price-role="sale"]');
    const compareEl = container.querySelector('[data-b2b-price-role="compare"]');

    if (fallbackEl) fallbackEl.style.display = '';
    if (saleEl) saleEl.style.display = 'none';
    if (compareEl) compareEl.style.display = 'none';
  };

  api.isMatrixReady = function () {
    const payload = window.B2BPricingMatrix;
    return !!(
      payload &&
      payload.isB2B === true &&
      payload.matrix &&
      Array.isArray(payload.matrix.rules) &&
      payload.matrix.rules.length > 0 &&
      payload.customerTier
    );
  };

  api.updateContainer = function (container) {
    if (!container) return;

    const fallbackTextEl = container.querySelector('[data-b2b-fallback-text]');
    const saleTextEl = container.querySelector('[data-b2b-price-text]');
    const compareTextEl = container.querySelector('[data-b2b-compare-text]');
    const fallbackEl = container.querySelector('[data-b2b-price-role="fallback"]');
    const saleEl = container.querySelector('[data-b2b-price-role="sale"]');
    const compareEl = container.querySelector('[data-b2b-price-role="compare"]');

    const baseCentsRaw = api.parseNumber(container.getAttribute('data-b2b-base-price')); // cents (e.g. 11064)
    const productCost = api.parseNumber(container.getAttribute('data-b2b-product-cost')); // decimal (e.g. 65.86)
    const qty = parseInt(container.getAttribute('data-b2b-qty') || '1', 10);

    if (baseCentsRaw === null || !Number.isFinite(qty) || qty <= 0) {
      api.showFallback(container);
      return;
    }

    const baseCents = Math.round(baseCentsRaw);
    const compareLineCents = baseCents * qty;

    // Always sync fallback/compare to base * qty
    const compareFormatted = api.formatMoney(compareLineCents, container);
    if (fallbackTextEl) fallbackTextEl.innerHTML = compareFormatted;
    if (compareTextEl) compareTextEl.innerHTML = compareFormatted;

    // Matrix not ready? => keep fallback
    if (!api.isMatrixReady() || productCost === null) {
      api.showFallback(container);
      return;
    }

    const pricingPayload = window.B2BPricingMatrix;
    const matchingRule = api.findMatchingRule(pricingPayload.matrix.rules, productCost);

    if (!matchingRule) {
      api.showFallback(container);
      return;
    }

    const discountPercentage = api.parseNumber(matchingRule[pricingPayload.customerTier]);

    if (discountPercentage === null || discountPercentage <= 0) {
      api.showFallback(container);
      return;
    }

    const saleUnitCents = Math.round(baseCents * (1 - discountPercentage / 100));
    const saleLineCents = saleUnitCents * qty;

    if (!Number.isFinite(saleLineCents) || saleLineCents <= 0 || saleLineCents >= compareLineCents) {
      api.showFallback(container);
      return;
    }

    if (saleTextEl) saleTextEl.innerHTML = api.formatMoney(saleLineCents, container);

    if (fallbackEl) fallbackEl.style.display = 'none';
    if (saleEl) saleEl.style.display = '';
    if (compareEl) compareEl.style.display = '';
  };

  /**
   * Returns the effective line total in cents (excl. VAT), using:
   * - base (excl VAT) * qty if no rule/discount
   * - discounted sale (excl VAT) * qty when rule matches
   */
  api.getEffectiveLineCents = function (container) {
    const baseCentsRaw = api.parseNumber(container.getAttribute('data-b2b-base-price'));
    const productCost = api.parseNumber(container.getAttribute('data-b2b-product-cost'));
    const qty = parseInt(container.getAttribute('data-b2b-qty') || '1', 10);

    if (baseCentsRaw === null || !Number.isFinite(qty) || qty <= 0) return null;

    const baseCents = Math.round(baseCentsRaw);
    const compareLineCents = baseCents * qty;

    // If matrix not ready -> fallback = compareLineCents
    if (!api.isMatrixReady() || productCost === null) return compareLineCents;

    const pricingPayload = window.B2BPricingMatrix;
    const matchingRule = api.findMatchingRule(pricingPayload.matrix.rules, productCost);
    if (!matchingRule) return compareLineCents;

    const discountPercentage = api.parseNumber(matchingRule[pricingPayload.customerTier]);
    if (discountPercentage === null || discountPercentage <= 0) return compareLineCents;

    const saleUnitCents = Math.round(baseCents * (1 - discountPercentage / 100));
    const saleLineCents = saleUnitCents * qty;

    if (!Number.isFinite(saleLineCents) || saleLineCents <= 0 || saleLineCents >= compareLineCents) {
      return compareLineCents;
    }

    return saleLineCents;
  };

  api.refresh = function (root) {
    const scope = root && root.querySelectorAll ? root : document;
    const containers = scope.querySelectorAll('.mini-cart [data-b2b-price-container]');
    if (!containers || containers.length === 0) return;

    api._isApplying = true;
    try {
      let subtotalCents = 0;

      for (let i = 0; i < containers.length; i += 1) {
        const c = containers[i];
        api.updateContainer(c);

        const lineCents = api.getEffectiveLineCents(c);
        if (typeof lineCents === 'number' && Number.isFinite(lineCents)) {
          subtotalCents += lineCents;
        }
      }

      // Hide Shopify “amount saved” (not based on matrix)
      const saved = document.querySelector('.mini-cart .mini-cart__amount-saved');
      if (saved) saved.style.display = 'none';

      // Overwrite displayed total (display-only) with B2B subtotal excl. VAT
      const totalEl = document.querySelector('.mini-cart [data-b2b-cart-total]');
      if (totalEl) {
        totalEl.innerHTML = api.formatMoney(subtotalCents, containers[0]);
      }
    } finally {
      api._isApplying = false;
    }
  };

  api.refreshWithRetry = function () {
    api.refresh(document);

    const hasContainers = document.querySelectorAll('.mini-cart [data-b2b-price-container]').length > 0;
    if (!hasContainers) return;

    if (api.isMatrixReady()) {
      if (api._retryTimer) {
        clearInterval(api._retryTimer);
        api._retryTimer = null;
      }
      return;
    }

    // only 1 retry timer at a time
    if (api._retryTimer) return;

    let attempts = 0;
    const maxAttempts = 15; // ~3s at 200ms
    api._retryTimer = setInterval(function () {
      attempts += 1;
      api.refresh(document);

      if (api.isMatrixReady() || attempts >= maxAttempts) {
        clearInterval(api._retryTimer);
        api._retryTimer = null;
      }
    }, 200);
  };

  api.scheduleRefresh = function () {
    if (api._scheduled) return;
    api._scheduled = true;

    // debounce to wait for DOM swaps to finish
    api._scheduleTimer = setTimeout(function () {
      api._scheduled = false;
      api.refreshWithRetry();
    }, 60);
  };

  // Initial
  document.addEventListener('DOMContentLoaded', function () {
    api.scheduleRefresh();
  });

  // Warehouse: after _rerender() it dispatches theme:loading:end
  document.addEventListener('theme:loading:end', function () {
    api.scheduleRefresh();
  });

  // Catch Warehouse re-render even when event does NOT bubble (use capture)
  document.addEventListener(
    'cart:rerendered',
    function () {
      api.scheduleRefresh();
    },
    true
  );

  // Theme editor
  document.addEventListener('shopify:section:load', function () {
    api.scheduleRefresh();
  });

  // Apply on opening mini-cart
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest && e.target.closest('[data-action="toggle-mini-cart"]');
    if (!toggle) return;
    setTimeout(function () {
      api.scheduleRefresh();
    }, 0);
  });

  // Observe ONLY direct child changes of #mini-cart (no subtree = no feedback loop)
  document.addEventListener('DOMContentLoaded', function () {
    const miniCart = document.getElementById('mini-cart');
    if (!miniCart) return;

    const contentObserver = new MutationObserver(function () {
      if (api._isApplying) return; // ignore our own updates
      api.scheduleRefresh();
    });
    contentObserver.observe(miniCart, { childList: true, subtree: false });

    const attrObserver = new MutationObserver(function () {
      if (miniCart.getAttribute('aria-hidden') === 'false') {
        api.scheduleRefresh();
      }
    });
    attrObserver.observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });
  });

  api.initialized = true;
})();
//B2B Mini Cart Logic// End

// ===============================
// B2B Cloud Search (stable v1)
// - Overlay (zoekbalk) scoped naar zichtbare overlay containers
// - /a/search only scoped naar /a/search
// - Fix: patches ALL results (per-item container detection)
// - Fix: works on paste (burst patch)
// ===============================
(function () {
  if (window.__B2BCloudSearchStableV1) return;
  window.__B2BCloudSearchStableV1 = true;

  // Debug:
  // localStorage.setItem('b2b_cs_debug','1'); location.reload();
  var DEBUG = localStorage.getItem('b2b_cs_debug') === '1';
  function log() { if (DEBUG) console.log.apply(console, arguments); }

  // Hard stop voor non-b2b
  function isB2B() {
    return !!(window.B2BPricingMatrix && window.B2BPricingMatrix.isB2B === true);
  }
  if (!isB2B()) return;

  var VIEW_SUFFIX = 'b2b-price-data';

  // Never touch cart/mini-cart
  var EXCLUDE_ROOT_SELECTOR =
    '#mini-cart, [data-mini-cart], .mini-cart, .cart-drawer, [data-cart-drawer], form[action*="/cart"]';

  // Product nodes (CloudSearch varies per implementation)
  var PRODUCT_NODE_SELECTOR = [
    'a[href*="/products/"]',
    '[data-url*="/products/"]',
    '[data-href*="/products/"]',
    '[data-product-url*="/products/"]',
    '[data-handle]',
    '[data-product-handle]',
    '[data-item-handle]',
    '[onclick*="/products/"]'
  ].join(',');

  // Price host selectors inside a single item container
  var PRICE_HOST_SELECTORS = [
    '[data-price]',
    '.price-list',
    '.product-item__price-list',
    '.product-item__price',
    '.price',
    '.money',
    '[class*="price"]'
  ];

  // Overlay root selectors (search dropdown / drawer / autocomplete)
  var OVERLAY_ROOT_SELECTORS = [
    '[data-predictive-search]',
    '.predictive-search',
    '.predictive-search__results',
    '.search-drawer',
    '.search-drawer__results',
    '.search__results',
    '.header-search',
    '.header__search',
    '[class*="cloudsearch"]',
    '[class*="cloud-search"]',
    '[id*="cloudsearch"]',
    '[id*="cloud-search"]',
    '[class*="autocomplete"]',
    '[class*="instant-search"]',
    '[class*="suggest"]'
  ];

  function parseNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    var parsed = parseFloat(String(value).replace(',', '.').trim());
    return isNaN(parsed) ? null : parsed;
  }

  function findMatchingRule(rules, productCost) {
    if (!Array.isArray(rules)) return null;
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!rule) continue;

      var min = parseNumber(rule.min);
      var max = rule.max === null ? null : parseNumber(rule.max);

      var minOk = min === null ? true : productCost >= min;
      var maxOk = max === null ? true : productCost < max;

      if (minOk && maxOk) return rule;
    }
    return null;
  }

  function formatMoney(cents) {
    var moneyFormat =
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function calcB2BPrice(baseCents, productCost) {
  var payload = window.B2BPricingMatrix;
  if (!payload || !payload.matrix || !Array.isArray(payload.matrix.rules) || !payload.customerTier) return null;
  if (productCost === null) return null;

  var rule = findMatchingRule(payload.matrix.rules, productCost);
  if (!rule) return null;

  var discountPct = parseNumber(rule[payload.customerTier]);
  if (discountPct === null || discountPct <= 0) return null;

  var saleCents = Math.round(baseCents * (1 - (discountPct / 100)));
  if (!isFinite(saleCents) || saleCents <= 0 || saleCents >= baseCents) return null;

  return {
    saleCents: saleCents,
    compareCents: baseCents,
    discountLabel: '-' + Math.round(discountPct) + '%'
  };
}

  function handleFromUrl(urlLike) {
    if (!urlLike) return null;
    var s = String(urlLike);
    var idx = s.indexOf('/products/');
    if (idx === -1) return null;

    try {
      var sliced = s.slice(idx);
      var url = new URL(sliced, window.location.origin);
      var parts = url.pathname.split('/products/');
      if (parts.length < 2) return null;
      var handle = parts[1].split('/')[0].trim();
      return handle || null;
    } catch (e) {
      var raw = s.slice(idx + '/products/'.length);
      var handle2 = raw.split(/[/?#"'\s]/)[0];
      return handle2 ? handle2.trim() : null;
    }
  }

  // IMPORTANT: prefer handle from the product node itself (per result)
  function extractHandle(node) {
    if (!node) return null;

    var ds = node.dataset || {};
    var h =
      ds.handle ||
      ds.productHandle ||
      ds.itemHandle ||
      (node.getAttribute && (node.getAttribute('data-handle') || node.getAttribute('data-product-handle') || node.getAttribute('data-item-handle')));

    if (h && String(h).trim()) return String(h).trim();

    if (node.tagName === 'A') {
      var href = node.getAttribute('href');
      var h1 = handleFromUrl(href);
      if (h1) return h1;
    }

    var candidates = [
      ds.url,
      ds.href,
      ds.productUrl,
      node.getAttribute && node.getAttribute('data-url'),
      node.getAttribute && node.getAttribute('data-href'),
      node.getAttribute && node.getAttribute('data-product-url')
    ].filter(Boolean);

    for (var i = 0; i < candidates.length; i++) {
      var h2 = handleFromUrl(candidates[i]);
      if (h2) return h2;
    }

    var oc = node.getAttribute && node.getAttribute('onclick');
    var h3 = handleFromUrl(oc);
    if (h3) return h3;

    // fallback descendant anchor
    if (node.querySelector) {
      var a = node.querySelector('a[href*="/products/"]');
      if (a) return handleFromUrl(a.getAttribute('href'));
    }

    return null;
  }

  function findPriceHost(card) {
    if (!card || !card.querySelector) return null;

    for (var i = 0; i < PRICE_HOST_SELECTORS.length; i++) {
      var el = card.querySelector(PRICE_HOST_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function buildB2BHtml(doc, baseCents, calc) {
  var wrap = doc.createElement('div');

  // Match LDP markup/classes zodat layout + no-wrap CSS gelijk is
  wrap.className = 'product-item__price-list price-list';
  wrap.setAttribute('data-b2b-cs-price', '1');

  if (calc) {
    // ✅ Alleen sale price + badge, geen oude/compare prijs
    wrap.innerHTML =
      '<span class="price price--highlight" data-b2b-discount-label="' + calc.discountLabel + '">' +
        formatMoney(calc.saleCents) +
      '</span>';
    return wrap;
  }

  // Geen korting → alleen price
  wrap.innerHTML =
    '<span class="price">' + formatMoney(baseCents) + '</span>';

  return wrap;
}

  // Cache fetch: /products/<handle>?view=b2b-price-data
  var memCache = Object.create(null);
  function fetchB2BData(handle) {
    if (memCache[handle]) return memCache[handle];

    var key = 'b2b_price_data:' + handle;
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) {
        memCache[handle] = Promise.resolve(JSON.parse(cached));
        return memCache[handle];
      }
    } catch (e) {}

    var url = '/products/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(VIEW_SUFFIX);
    log('[B2B CS] fetch', url);

    memCache[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        try { if (json) sessionStorage.setItem(key, JSON.stringify(json)); } catch (e) {}
        return json;
      })
      .catch(function () { return null; });

    return memCache[handle];
  }

  // === KEY FIX ===
  // Find the smallest ancestor that looks like a single result item:
  // - contains a price host
  // - contains exactly 1 product node (prefer)
  // This prevents “only first result” issues.
  function findItemContainerFromProductNode(productNode) {
    if (!productNode || !productNode.parentElement) return null;

    var el = productNode;
    var best = null;

    for (var depth = 0; depth < 10 && el; depth++) {
      if (el.closest && el.closest(EXCLUDE_ROOT_SELECTOR)) return null;

      if (el.querySelector) {
        var hasPrice = !!findPriceHost(el);
        if (hasPrice) {
          var count = el.querySelectorAll(PRODUCT_NODE_SELECTOR).length;
          if (count === 1) return el; // perfect
          if (!best) best = el;       // fallback if never perfect
        }
      }

      el = el.parentElement;
    }

    // last-ditch: li/option tends to be per-item
    var li = productNode.closest && productNode.closest('li');
    if (li) return li;

    var opt = productNode.closest && productNode.closest('[role="option"]');
    if (opt) return opt;

    return best || productNode.parentElement;
  }

  function applyToItem(itemEl, handleFromNode) {
    if (!itemEl || !itemEl.querySelector) return;
    if (itemEl.closest && itemEl.closest(EXCLUDE_ROOT_SELECTOR)) return;
    if (itemEl.querySelector('[data-b2b-cs-price="1"]')) return;

    var host = findPriceHost(itemEl);
    if (!host) return;

    // Use handle from the specific product node first
    var handle = handleFromNode || extractHandle(itemEl);
    if (!handle) return;

    fetchB2BData(handle).then(function (data) {
      if (!data) return;

      var base = parseNumber(data.base_price_excl_vat_cents);
      var cost = parseNumber(data.product_cost_in_euro);
      if (base === null) return;

      var baseCents = Math.round(base);
      var calc = calcB2BPrice(baseCents, cost);

      // Inject first, hide original after
      var injected = buildB2BHtml(itemEl.ownerDocument || document, baseCents, calc);
      if (itemEl.querySelector('[data-b2b-cs-price="1"]')) return;

      host.insertAdjacentElement('afterend', injected);
      host.style.display = 'none';
    });
  }

  function isVisible(el) {
    if (!el) return false;
    var ariaHidden = el.getAttribute && el.getAttribute('aria-hidden');
    if (ariaHidden === 'true') return false;
    var rects = el.getClientRects ? el.getClientRects() : null;
    return !!(rects && rects.length);
  }

  function findOverlayRoots() {
    var roots = [];
    for (var i = 0; i < OVERLAY_ROOT_SELECTORS.length; i++) {
      var nodes = document.querySelectorAll(OVERLAY_ROOT_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j++) {
        if (isVisible(nodes[j])) roots.push(nodes[j]);
      }
    }
    // unique
    return Array.from(new Set(roots));
  }

  // Patch all items inside a scope
  function patchScope(scope) {
    if (!scope || !scope.querySelectorAll) return;

    var productNodes = scope.querySelectorAll(PRODUCT_NODE_SELECTOR);
    if (!productNodes || productNodes.length === 0) return;

    // Build unique item containers (so we patch each result once)
    var items = new Set();
    for (var i = 0; i < productNodes.length; i++) {
      var pn = productNodes[i];
      var item = findItemContainerFromProductNode(pn);
      if (!item) continue;
      items.add(item);
    }

    items.forEach(function (itemEl) {
      // try to derive handle from its own product node inside that item
      var node = itemEl.querySelector(PRODUCT_NODE_SELECTOR);
      var handle = extractHandle(node) || extractHandle(itemEl);
      applyToItem(itemEl, handle);
    });
  }

  function patchOverlay() {
    var roots = findOverlayRoots();
    for (var i = 0; i < roots.length; i++) patchScope(roots[i]);
  }

function isSearchPage() {
  return /\/a\/search(?:$|\/)/.test(window.location.pathname);
  // werkt voor /a/search én /nl/a/search én /en/a/search
}

  function patchSearchPage() {
    if (!isSearchPage()) return;
    patchScope(document);
  }

  // BURST patcher: very important for “paste article number”
  var burstTimer = null;
  function burst(fn, ms) {
    var start = Date.now();
    fn();
    if (burstTimer) clearInterval(burstTimer);

    burstTimer = setInterval(function () {
      fn();
      if (Date.now() - start > (ms || 2600)) {
        clearInterval(burstTimer);
        burstTimer = null;
      }
    }, 150);
  }

  function isSearchInput(el) {
    if (!el) return false;
    if (el.matches) {
      if (el.matches('input[type="search"]')) return true;
      if (el.matches('input[name="q"]')) return true;
      if (el.matches('input[id*="search" i]')) return true;
      if (el.matches('input[class*="search" i]')) return true;
    }
    var form = el.closest && el.closest('form');
    if (form && (form.action || '').indexOf('/search') !== -1) return true;
    return false;
  }

  // --- Events: type + paste ---
  document.addEventListener('input', function (e) {
    if (isSearchInput(e.target)) burst(patchOverlay, 2800);
  }, true);

  document.addEventListener('keyup', function (e) {
    if (isSearchInput(e.target)) burst(patchOverlay, 2800);
  }, true);

  document.addEventListener('paste', function (e) {
    if (!isSearchInput(e.target)) return;
    // paste updates value after this tick
    setTimeout(function () {
      burst(patchOverlay, 3200);
    }, 0);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (isSearchInput(e.target)) burst(patchOverlay, 1800);
  }, true);

  // --- Observe: overlay roots + search page ---
  var observedOverlay = new WeakSet();
  function observeOverlayRoots() {
    var roots = findOverlayRoots();
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (observedOverlay.has(r)) continue;
      observedOverlay.add(r);

      try {
        new MutationObserver(function () {
          burst(patchOverlay, 1800);
        }).observe(r, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  observeOverlayRoots();
  new MutationObserver(function () {
    observeOverlayRoots();
  }).observe(document.body, { childList: true, subtree: true });

  // Search page: results render async, so patch in bursts when DOM changes
  if (isSearchPage()) {
    burst(patchSearchPage, 1200);
    try {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            burst(patchSearchPage, 1200);
            break;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  // --- Network hook: after CloudSearch XHR/fetch results arrive ---
  function hookNetwork() {
    if (window.__b2b_cs_stable_net_hooked) return;
    window.__b2b_cs_stable_net_hooked = true;

    function isRelevant(u) {
      var s = String(u || '');
      return s.indexOf('search?type=product') !== -1 || s.indexOf('webclient-infield.html') !== -1;
    }

    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function () {
        var p = origFetch.apply(this, arguments);
        try {
          var req = arguments[0];
          var url = typeof req === 'string' ? req : (req && req.url) ? req.url : '';
          if (isRelevant(url)) {
            p.then(function () {
              // overlay + searchpage bursts
              burst(patchOverlay, 2200);
              burst(patchSearchPage, 1200);
            });
          }
        } catch (e) {}
        return p;
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var XHR = window.XMLHttpRequest;
      if (!XHR.prototype.__b2b_cs_stable_patched) {
        var origOpen = XHR.prototype.open;
        var origSend = XHR.prototype.send;

        XHR.prototype.open = function (method, url) {
          this.__b2b_cs_url = url;
          return origOpen.apply(this, arguments);
        };

        XHR.prototype.send = function () {
          var xhr = this;
          try {
            xhr.addEventListener('loadend', function () {
              if (isRelevant(xhr.__b2b_cs_url)) {
                burst(patchOverlay, 2200);
                burst(patchSearchPage, 1200);
              }
            });
          } catch (e) {}
          return origSend.apply(this, arguments);
        };

        XHR.prototype.__b2b_cs_stable_patched = true;
      }
    }
  }

  hookNetwork();

  log('[B2B CS] Stable v1 init done');
})();

/* =========================
   B2B Collection Pricing (GLOBAL)
   - nodig voor Recommendations / Recently Viewed (AJAX injected HTML)
   ========================= */
(function () {
  window.B2BPricingCollection = window.B2BPricingCollection || {};

  if (window.B2BPricingCollection.initialized) {
    // Zorg dat dynamic inserts alsnog refreshen
  } else {
    window.B2BPricingCollection.parseNumber = function (value) {
      if (value === null || value === undefined || value === '') return null;
      var parsed = parseFloat(String(value).replace(',', '.').trim());
      return isNaN(parsed) ? null : parsed;
    };

    window.B2BPricingCollection.findMatchingRule = function (rules, productCost) {
      if (!Array.isArray(rules)) return null;

      for (var i = 0; i < rules.length; i += 1) {
        var rule = rules[i];
        if (!rule) continue;

        var min = window.B2BPricingCollection.parseNumber(rule.min);
        var max = rule.max === null ? null : window.B2BPricingCollection.parseNumber(rule.max);

        var minOk = min === null ? true : productCost >= min;
        var maxOk = max === null ? true : productCost < max;

        if (minOk && maxOk) return rule;
      }

      return null;
    };

    window.B2BPricingCollection.formatMoney = function (cents, container) {
      var useCurrencyCode = container.getAttribute('data-b2b-currency-enabled') === 'true';
      var moneyFormat = useCurrencyCode
        ? container.getAttribute('data-b2b-money-format-with-currency')
        : container.getAttribute('data-b2b-money-format');

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      var currencyCode = container.getAttribute('data-b2b-currency-code') || 'EUR';
      var locale = document.documentElement.lang || navigator.language || 'en';
      var amount = cents / 100;

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currencyCode,
          currencyDisplay: useCurrencyCode ? 'code' : 'symbol'
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2) + (useCurrencyCode ? ' ' + currencyCode : '');
      }
    };

    window.B2BPricingCollection.updateContainer = function (container) {
      if (!container) return;

      var priceTextEl = container.querySelector('[data-b2b-price-text]');
      var priceEl = container.querySelector('[data-b2b-price-role="single"]');

      // Badge label altijd resetten vóór recalculatie
      if (priceEl) priceEl.removeAttribute('data-b2b-discount-label');

      var basePriceCents = window.B2BPricingCollection.parseNumber(container.getAttribute('data-b2b-base-price'));
      var productCost = window.B2BPricingCollection.parseNumber(container.getAttribute('data-b2b-product-cost'));

      if (basePriceCents === null) return;

      var roundedBasePriceCents = Math.round(basePriceCents);
      var finalPriceCents = roundedBasePriceCents;

      var pricingPayload = window.B2BPricingMatrix;

      if (
        pricingPayload &&
        pricingPayload.isB2B &&
        pricingPayload.matrix &&
        pricingPayload.customerTier &&
        productCost !== null
      ) {
        var matchingRule = window.B2BPricingCollection.findMatchingRule(pricingPayload.matrix.rules, productCost);

        if (matchingRule) {
          var discountPercentage = window.B2BPricingCollection.parseNumber(matchingRule[pricingPayload.customerTier]);

          if (discountPercentage !== null && discountPercentage > 0) {
            var calculatedSalePrice = Math.round(roundedBasePriceCents * (1 - (discountPercentage / 100)));

            if (isFinite(calculatedSalePrice) && calculatedSalePrice > 0 && calculatedSalePrice < roundedBasePriceCents) {
              finalPriceCents = calculatedSalePrice;

              // Badge label: "-20%" etc.
              if (priceEl) {
                priceEl.setAttribute('data-b2b-discount-label', '-' + Math.round(discountPercentage) + '%');
              }
            }
          }
        }
      }

      if (priceTextEl) {
        priceTextEl.innerHTML = window.B2BPricingCollection.formatMoney(finalPriceCents, container);
      }
    };

    window.B2BPricingCollection.refresh = function (root) {
      var scope = root && root.querySelectorAll ? root : document;
      var containers = scope.querySelectorAll('[data-b2b-collection-price-container]');

      for (var i = 0; i < containers.length; i += 1) {
        window.B2BPricingCollection.updateContainer(containers[i]);
      }
    };

    window.B2BPricingCollection.initialized = true;
  }

  // ---- Auto refresh bij dynamic content (recommendations / recently viewed) ----
  var scheduled = false;
  var scheduledRoot = null;

  function scheduleRefresh(root) {
    scheduledRoot = root || document;
    if (scheduled) return;

    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      window.B2BPricingCollection.refresh(scheduledRoot || document);
      scheduledRoot = null;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleRefresh(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scheduleRefresh(event.target || document);
  });

  // Observe injected HTML (scripts in injected HTML runnen niet, dus we triggeren refresh hier)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j += 1) {
        var node = m.addedNodes[j];
        if (!node || node.nodeType !== 1) continue;

        // Zodra er nieuwe price containers bijkomen -> refresh die subtree
        if (
          (node.matches && node.matches('[data-b2b-collection-price-container]')) ||
          (node.querySelector && node.querySelector('[data-b2b-collection-price-container]'))
        ) {
          scheduleRefresh(node);
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();